const mainThemeColor = '#FED104'
const mainThemeColorLight = '#FED104'
const dimBackgroundColor = 'rgba(0,0,0,0.8)'
export const ConfigImport = {
  appName: 'Konya Bizz',
  appDisplayName: 'Konya Bizz',
  version: '0.8',
  build: '132',
  organization: 'Konya BB',
  theme: {
    default: {
      loginPage: {
        topBarColor: mainThemeColor,
        loginBtnColor: mainThemeColor,
        colorTextColor: mainThemeColor,
        organizationLogo: '/theme/konya/bizz-logo.svg'
      },
      homePage: {
        topBarColor: mainThemeColor,
        bottomBorderColor: mainThemeColorLight,
        loadingGif: 'url(/theme/spec/loading.gif)',
        loadingBackgroundColor: '#FFFFFF'
      },
      sideMenu: {
        topBarColor: mainThemeColorLight,
        fontColor: mainThemeColorLight,
        buttonColor: mainThemeColorLight
      },
      previewPage: {
        topBarColor: mainThemeColorLight,
        backgroundColor: dimBackgroundColor,
        bottomBorderColor: mainThemeColorLight,
        buttonColor: mainThemeColorLight,
        progressBarColor: mainThemeColorLight
      },
      emojiPage: {
        tabSelectedColor: mainThemeColorLight
      },
      messageContainer: {
        messageBalloon: {
          hasMoreTextLinkColor: '#1976D2',
          incomingMessageBgColor: '#CCCCCC',
          outgoingMessageBgColor: '#fde9e9',
          addToGroupColor: '#00DDDD'
        }
      },
      common: {
        coloredTextColor: mainThemeColor
      }
    }
  },

  // serviceURLs: {
  //   loginURL: 'https://spec.spexco.com:3738/lb',
  //   uploadURL: 'https://spec.spexco.com:3738/ufeb',
  //   uploadURL2: 'https://spec.spexco.com:3738',
  //   authURL: 'https://spec.spexco.com:3738/Auth'
  // },
  // socketInfo: {
  //   connection: null,
  //   qrConnection: null,
  //   baseUrl: 'wss://spec.spexco.com:3737',
  //   qrUrl: 'wss://spec.spexco.com:3739',
  //   browserUuid: '',
  //   source: 'browser',
  //   url: 'ws://192.168.1.12:3737?userid=mustafa&sec=f6d425e830e85c74d89ba0114dd93a36&source=browser&enc=true',
  //   protocol: 'specMessage',
  //   reconnectTimer: 1,
  //   reconnectProgress: 2,
  //   maxReconnectTimer: 30
  // },
  sinfo: {
    ien: true // isEncrypted
  }
}
